import {ActionReducerMapBuilder} from '@reduxjs/toolkit';

import {transformFilterExpressionDtoToExpressionArray} from 'features/predicate-expression-form-list';

import {IReportConfigurationSliceState} from '../report-configuration-types';
import {loadDdRestrictions, updateDdRestrictions} from './dd-restrictions-configuration-thunks';

export const createDdRestrictionsConfigurationExtraReducer = (
    builder: ActionReducerMapBuilder<IReportConfigurationSliceState>,
) => {
    builder.addCase(loadDdRestrictions.fulfilled, (state, {payload: ddRestrictionData}) => {
        const {
            ddRestrictionsExpressionDto,
            tableReportFilterLookups,
        } = ddRestrictionData ?? {};

        if (ddRestrictionsExpressionDto) {
            state.drilldownSettings.ddRestrictions = transformFilterExpressionDtoToExpressionArray(
                ddRestrictionsExpressionDto,
            );
        }

        state.ddLookups.filters = tableReportFilterLookups;
    });
    builder.addCase(updateDdRestrictions.fulfilled, (state, {meta}) => {
        const {restrictions} = meta.arg;
        state.drilldownSettings.ddRestrictions = transformFilterExpressionDtoToExpressionArray(restrictions);
    });
};

export const createDdRestrictionsConfigurationReducer = <S extends IReportConfigurationSliceState>() => ({
    purgeDrilldownRestrictions(
        state: S,
    ) {
        state.drilldownSettings.ddRestrictions = undefined;
    },
});
